import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StylistSettingsScreen from './StylistSettingsScreen';
import GoalEditScreen from './GoalEditScreen';
import ActionEditScreen from './ActionEditScreen';
import HistoryScreen from './HistoryScreen';
import HelpScreen from './HelpScreen';
import InquiryThread from './InquiryThread';
import DevInquiryList from './DevInquiryList';
import DevInquiryThread from './DevInquiryThread';
import UpdatesScreen from './UpdatesScreen';

/** Phase 5 — stylist settings stack (nested routes under /settings). */
export default function SettingsStack() {
  return (
    <div className="kuroco-shell app">
      <Routes>
        <Route index element={<StylistSettingsScreen />} />
        <Route path="goaledit" element={<GoalEditScreen />} />
        <Route path="actionedit" element={<ActionEditScreen />} />
        <Route path="history" element={<HistoryScreen />} />
        <Route path="help" element={<HelpScreen />} />
        <Route path="help/inquiries/:id" element={<InquiryThread />} />
        <Route path="help/dev" element={<DevInquiryList />} />
        <Route path="help/dev/:id" element={<DevInquiryThread />} />
        <Route path="updates" element={<UpdatesScreen />} />
      </Routes>
    </div>
  );
}
